import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AppVersionService } from './api/appVersion.service';
import { CustomersService } from './api/customers.service';
import { EstatesService } from './api/estates.service';
import { LeadsService } from './api/leads.service';
import { MarketAnalysesService } from './api/marketAnalyses.service';
import { MessagesService } from './api/messages.service';
import { NewsService } from './api/news.service';
import { NotificationsService } from './api/notifications.service';
import { SocialFeedService } from './api/socialFeed.service';
import { StaffService } from './api/staff.service';
import { UsersService } from './api/users.service';
import { ValuationsService } from './api/valuations.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AppVersionService,
    CustomersService,
    EstatesService,
    LeadsService,
    MarketAnalysesService,
    MessagesService,
    NewsService,
    NotificationsService,
    SocialFeedService,
    StaffService,
    UsersService,
    ValuationsService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
